import React from "react";

export default function SearchInputsRow({
  renderSearchInput,
  refs,
}) {
  const {
    invoiceCodeRef,
    invoiceDateRef,
    customerRef,
    addressRef,
    governorateRef,
    phoneRef,
    invoiceCategoriesRef,
    dateCreatedRef,
    userNameRef,
    statusRef,
    totalPriceRef,
  } = refs;

  return (
    <tr>
      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
        <input type="checkbox" className="form-checkbox" />
      </th>
      {renderSearchInput("invoiceCode", "كود", invoiceCodeRef)}
      {renderSearchInput("invoiceDate", "التاريخ", invoiceDateRef)}
      {renderSearchInput("customer", "العميل", customerRef)}
      {renderSearchInput("createdBy", "السكرتريه", customerRef)}
      {renderSearchInput("address", "العنوان", addressRef)}
      {renderSearchInput("governorate", "المحافظة", governorateRef)}
      {renderSearchInput("phone", "الهاتف", phoneRef)}
      {renderSearchInput("invoiceCategories", "الفئات", invoiceCategoriesRef)}
      {renderSearchInput("dailyDate", "تاريخ اضافه مندوب", dateCreatedRef)}
      {renderSearchInput("fullName", "المندوب", userNameRef)}
      {renderSearchInput("status", "الحالة", statusRef)}
      {renderSearchInput("totalPrice", "الإجمالي", totalPriceRef)}
    </tr>
  );
} 